module.exports = __webpack_public_path__ + "static/img/team-cd-01.9133ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/estate/team/team-cd-01.jpg
// module id = STeX
// module chunks = 1